module.exports = __webpack_public_path__ + "img/logo-mapa-inverse.07ce9c35.svg";